import {
  ButtonPrimary,
  ButtonTertiary,
  Checkbox,
  DialogBox,
  DialogBoxBody,
  DialogBoxHeader,
} from '@americanexpress/dls-react';
import React from 'react';
import PropTypes from 'prop-types';

export const FxConfirmationPopUp = (
  {
    id,
    heading,
    icon,
    body,
    ackonwledgmentMsg,
    theme,
    headerStyle,
    bodyStyle,
    primaryButtonLabel,
    onPrimaryButtonClick,
    primaryButtonType,
    tertiaryButtonLabel,
    onTertiaryButtonClick,
  }
) => {
  const [isAcknowledged, setIsAcknowledged] = React.useState(false);

  const primaryButton = primaryButtonLabel && (onPrimaryButtonClick || primaryButtonType === 'submit') && (
    <ButtonPrimary
      id={`${id}-ButtonPrimary`}
      className="margin-auto-lr margin-1-b margin-3-t"
      onClick={onPrimaryButtonClick}
      disabled={ackonwledgmentMsg && !isAcknowledged}
      theme={{
        display: 'block',
        width: '100%',
      }}
      type={primaryButtonType}
    >
      {primaryButtonLabel}
    </ButtonPrimary>
  );

  const tertiaryButton = tertiaryButtonLabel && onTertiaryButtonClick && (
    <ButtonTertiary
      id={`${id}-ButtonTertiary`}
      className="margin-auto-lr"
      onClick={onTertiaryButtonClick}
      theme={{
        display: 'block',
        width: '100%',
      }}
    >
      {tertiaryButtonLabel}
    </ButtonTertiary>
  );

  return (
    <DialogBox
      id={`${id}-DialogBox`}
      theme={theme}
    >
      <DialogBoxHeader id={`${id}-DialogBoxHeader`}>
        {icon && icon}
        <p style={{ ...headerStyle }}>{heading}</p>
      </DialogBoxHeader>
      <DialogBoxBody id={`${id}-DialogBoxBody`}>
        {ackonwledgmentMsg && (
          <>
            <Checkbox
              id={`${id}-AckonwledgmentCheckBox`}
              checked={isAcknowledged}
              label={ackonwledgmentMsg}
              onChange={() => setIsAcknowledged(!isAcknowledged)}
            />
          </>
        )}

        <p style={{ ...bodyStyle }}>{body}</p>
        {primaryButton}
        {tertiaryButton}
      </DialogBoxBody>
    </DialogBox>
  );
};

FxConfirmationPopUp.propTypes = {
  id: PropTypes.string,
  heading: PropTypes.string,
  icon: PropTypes.node,
  body: PropTypes.string,
  ackonwledgmentMsg: PropTypes.string,
  primaryButtonLabel: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  primaryButtonType: PropTypes.string,
  tertiaryButtonLabel: PropTypes.string,
  onTertiaryButtonClick: PropTypes.func,
  theme: PropTypes.shape({}),
  headerStyle: PropTypes.shape({}),
  bodyStyle: PropTypes.shape({}),
};

FxConfirmationPopUp.defaultProps = {
  id: 'confirmationPopUp',
  heading: 'Are you sure you want to do this?',
  body: 'Any information you have entered will be lost.',
  primaryButtonLabel: 'Leave',
  onPrimaryButtonClick: null,
  primaryButtonType: 'button',
  tertiaryButtonLabel: 'Stay',
  onTertiaryButtonClick: null,
  theme: {},
  headerStyle: {},
  bodyStyle: {},
};
